/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const ProductCreatePage = lazyLoad(
  () => import('./index'),
  module => module.ProductCreatePage
);
